import React, { useRef } from "react";
import styles from "./styles.module.scss";
import { SpaceModel } from "app/models";
import { cls } from "app/utils";
import { Loading } from "app/components/Wrappers";
import { uuid } from "app/utils/uuid";
import SpaceCardXl from "app/components/SpaceCardXl";
import { Link, useHistory } from "react-router-dom";
import CreateNewXlButton from "app/components/Button/CreateNewXlButton";
import SetupHint from "app/components/AcademySetup/SetupHint";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
export interface SpacesListProps {
  spacesData?: SpaceModel[];
  pending?: boolean;
  containerRef?: any;
  upgradeHandler: () => void;
  isDemo?: boolean;
  selectedListValue?: any;
}

const SpacesList = ({
  spacesData,
  pending,
  containerRef,
  upgradeHandler,
  isDemo,
  selectedListValue,
}: SpacesListProps) => {
  const history = useHistory();
  // The checklist's "Invite your first athlete" coachmark points here when the
  // coach already has spaces (the empty state anchors its own in Spaces/index).
  const createSpaceRef = useRef<HTMLSpanElement>(null);

  const { self } = useSelector((state: RootState) => state.user);

  const newSingle = () => {
    if (!self?.planPermissions?.includes("create_spaces")) {
      return upgradeHandler();
    }

    return history.push("/spaces/new");
  };

  const CreateNewSpace = () => {
    if (
      (pending && spacesData?.length === 0) ||
      isDemo ||
      selectedListValue?.object === "segment"
    ) {
      return null;
    }

    // The coachmark portals into <body> but stays this span's React child,
    // so inside it a "Got it" click would bubble into newSingle.
    // The accessible control is CreateNewXlButton's own DropdownButton
    // trigger (role=button, a Tab stop, Enter/Space): this span only carries
    // the click up to it and anchors the coachmark, so it takes no role or
    // tab stop of its own — that made two controls of one action.
    return (
      <>
        <span
          className={styles.create_space}
          onClick={newSingle}
          ref={createSpaceRef}
        >
          <CreateNewXlButton className={styles.create_space_button} />
        </span>
        <SetupHint
          itemKey="invite_athlete"
          anchorRef={createSpaceRef}
          placement="bottom-end"
          arrowAtAnchorCenter
        />
      </>
    );
  };

  return (
    <div className={cls(styles.spaces_list_container)}>
      <div className={styles.space_cards_list}>
        <CreateNewSpace />
        {spacesData?.map((data: SpaceModel) => {
          if (data?.space) {
            return (
              <Link
                key={data.space?.id || uuid()}
                to={`/spaces/${data.space?.id}`}
              >
                <SpaceCardXl spaceData={data.space} />
              </Link>
            );
          }
          return (
            <Link key={data?.id || uuid()} to={data?.timelineUrl}>
              <SpaceCardXl spaceData={data} />
            </Link>
          );
        })}
      </div>
      {pending && (
        <Loading isLoading loadType="spinner" className={styles.loading} />
      )}
      {spacesData?.length > 0 && spacesData?.[0].space && (
        <div ref={containerRef} />
      )}
    </div>
  );
};

export default SpacesList;
